async function ccFetchCart() {
  const res = await fetch('/cart.js', { credentials: 'same-origin' });
  return res.json();
}

async function ccAddVariant(variantId, qty = 1) {
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
  });
}

async function ccChangeLine(line, qty) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ line, quantity: qty })
  });
}

function ccInitBlock(blockEl) {
  const track = blockEl.querySelector('[data-cc-track]');
  const prevBtn = blockEl.querySelector('[data-cc-prev]');
  const nextBtn = blockEl.querySelector('[data-cc-next]');

  if (track && prevBtn && nextBtn) {
    prevBtn.addEventListener('click', () => track.scrollBy({ left: -340, behavior: 'smooth' }));
    nextBtn.addEventListener('click', () => track.scrollBy({ left: 340, behavior: 'smooth' }));
  }

  const sync = async () => {
    const cart = await ccFetchCart();
    const items = cart.items || [];
    blockEl.querySelectorAll('input[data-cc-variant]').forEach((cb) => {
      const vId = Number(cb.dataset.ccVariant);
      const inCart = items.some(i => Number(i.variant_id) === vId && i.quantity > 0);
      cb.checked = inCart;
    });
  };

  sync().catch(() => {});

  blockEl.addEventListener('change', async (e) => {
    const cb = e.target;
    if (!cb.matches('input[data-cc-variant]')) return;

    cb.disabled = true;
    try {
      const variantId = Number(cb.dataset.ccVariant);
      const cart = await ccFetchCart();

      if (cb.checked) {
        await ccAddVariant(variantId, 1);
      } else {
        const lineIndex = (cart.items || []).findIndex(i => Number(i.variant_id) === variantId);
        if (lineIndex >= 0) await ccChangeLine(lineIndex + 1, 0);
      }

      await sync();
    } catch (err) {
      cb.checked = !cb.checked;
    } finally {
      cb.disabled = false;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-completeaza-comanda]').forEach(ccInitBlock);
});
